var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call_4_",
    "data-name": "call (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.184,
    height: 91.987,
    viewBox: "0 0 96.184 91.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85327",
    "data-name": "Group 85327",
    transform: "translate(1.032 10.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85318",
    "data-name": "Group 85318",
    transform: "translate(0 0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85316",
    "data-name": "Group 85316",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241605",
    "data-name": "Path 241605",
    d: "M33.11,62.056l-5.594-6.6a7.028,7.028,0,0,0-9.872-.837l-4.258,3.566A23.339,23.339,0,0,0,6.018,82.84,78.05,78.05,0,0,0,43.6,128.853l2.575,1.393a23.444,23.444,0,0,0,26.194-2.65l3.894-3.26a7,7,0,0,0,.888-9.851l-5.54-6.637a7.027,7.027,0,0,0-9.9-.876l-1.643,1.376a7.033,7.033,0,0,1-7.948.747l-2.731-1.529A44.894,44.894,0,0,1,28.155,80.808a7,7,0,0,1,2.238-7.3l1.862-1.56a7,7,0,0,0,.854-9.888Z",
    transform: "translate(-5.017 -52.973)",
    fill: "#ffdbb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85317",
    "data-name": "Group 85317",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241606",
    "data-name": "Path 241606",
    d: "M17.645,54.619l-4.258,3.566A23.338,23.338,0,0,0,6.018,82.844,78.05,78.05,0,0,0,43.6,128.857l2.575,1.393a23.444,23.444,0,0,0,26.194-2.65l3.894-3.26a7,7,0,0,0,2.385-6.7l-8.707,6.895-.083.067a19.425,19.425,0,0,1-21.824,2.208l-2.575-1.393A73.7,73.7,0,0,1,9.761,81.71a19.405,19.405,0,0,1,6.083-20.483l9.589-7.442a7.034,7.034,0,0,0-7.788.834Z",
    transform: "translate(-5.017 -52.978)",
    fill: "#fda639"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85326",
    "data-name": "Group 85326",
    transform: "translate(10.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85322",
    "data-name": "Group 85322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85319",
    "data-name": "Group 85319",
    transform: "translate(0 0.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241607",
    "data-name": "Path 241607",
    d: "M72.346,73.33l.1.1,1.775-1.487a7,7,0,0,0,.854-9.889l-5.594-6.6a7.028,7.028,0,0,0-9.872-.837l-1.752,1.467.052.082Z",
    transform: "translate(-57.863 -52.973)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85320",
    "data-name": "Group 85320",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241608",
    "data-name": "Path 241608",
    d: "M57.916,56.121l2.534,3.014,6.954-5.4c-3.435-1.886-7.009-.263-9.54,2.3Z",
    transform: "translate(-57.864 -52.919)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85321",
    "data-name": "Group 85321",
    transform: "translate(9.236 14.455)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4940",
    "data-name": "Ellipse 4940",
    cx: 1.338,
    cy: 1.338,
    rx: 1.338,
    ry: 1.338,
    fill: "#8e8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85323",
    "data-name": "Group 85323",
    transform: "translate(44.118 52.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241609",
    "data-name": "Path 241609",
    d: "M289.373,316.53l-5.54-6.637a7.027,7.027,0,0,0-9.9-.876l-1.643,1.376c-.017.014-.034.026-.051.039l.118.335,14.368,17.091,1.764-1.477A7,7,0,0,0,289.373,316.53Z",
    transform: "translate(-272.235 -307.375)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85324",
    "data-name": "Group 85324",
    transform: "translate(56.136 64.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241610",
    "data-name": "Path 241610",
    d: "M335.863,372.84a7.035,7.035,0,0,0,1.381-5.669l-6.617,5.24,2.469,2.936A22.517,22.517,0,0,0,335.863,372.84Z",
    transform: "translate(-330.627 -367.171)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85325",
    "data-name": "Group 85325",
    transform: "translate(46.513 58.694)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4941",
    "data-name": "Ellipse 4941",
    cx: 1.338,
    cy: 1.338,
    rx: 1.338,
    ry: 1.338,
    fill: "#8e8e8e"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_85353",
    "data-name": "Group 85353",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85341",
    "data-name": "Group 85341",
    transform: "translate(39.267 5.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85328",
    "data-name": "Group 85328",
    transform: "translate(0 9.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241611",
    "data-name": "Path 241611",
    d: "M209.106,72.114a18.262,18.262,0,0,0-10.825,33l1.066,8.083,6.353-4.865a18.275,18.275,0,1,0,3.405-36.223Z",
    transform: "translate(-190.798 -72.114)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85332",
    "data-name": "Group 85332",
    transform: "translate(19.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85329",
    "data-name": "Group 85329",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241612",
    "data-name": "Path 241612",
    d: "M302.748,25.391A18.264,18.264,0,0,0,287.2,53.312l-2.15,8.008,8.025-2.146a18.283,18.283,0,1,0,9.672-33.783Z",
    transform: "translate(-284.44 -25.391)",
    fill: "#ffdbb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85330",
    "data-name": "Group 85330",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241613",
    "data-name": "Path 241613",
    d: "M288.557,43.661a18.285,18.285,0,0,1,16.25-18.154,18.519,18.519,0,0,0-2.058-.116A18.264,18.264,0,0,0,287.2,53.312l-2.15,8.008,4.434-1.186,1.832-6.822a18.154,18.154,0,0,1-2.762-9.652Z",
    transform: "translate(-284.441 -25.391)",
    fill: "#fda639"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85331",
    "data-name": "Group 85331",
    transform: "translate(16.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241614",
    "data-name": "Path 241614",
    d: "M365.458,25.391a18.518,18.518,0,0,0-2.058.116,18.266,18.266,0,0,1,0,36.308,18.514,18.514,0,0,0,2.058.116,18.27,18.27,0,1,0,0-36.539Z",
    transform: "translate(-363.4 -25.391)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85336",
    "data-name": "Group 85336",
    transform: "translate(27.29 14.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85333",
    "data-name": "Group 85333",
    transform: "translate(1.029 1.029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4942",
    "data-name": "Ellipse 4942",
    cx: 3.087,
    cy: 3.087,
    rx: 3.087,
    ry: 3.087,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85334",
    "data-name": "Group 85334",
    transform: "translate(1.029 1.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241615",
    "data-name": "Path 241615",
    d: "M331.281,102.251a3.085,3.085,0,0,1,1.646-2.729,3.087,3.087,0,1,0,0,5.459A3.085,3.085,0,0,1,331.281,102.251Z",
    transform: "translate(-328.4 -99.164)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85335",
    "data-name": "Group 85335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241616",
    "data-name": "Path 241616",
    d: "M327.516,102.4a4.116,4.116,0,1,1,4.116-4.116A4.121,4.121,0,0,1,327.516,102.4Zm0-6.174a2.058,2.058,0,1,0,2.058,2.058A2.06,2.06,0,0,0,327.516,96.222Z",
    transform: "translate(-323.4 -94.164)",
    fill: "#8e8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85340",
    "data-name": "Group 85340",
    transform: "translate(39.638 14.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85337",
    "data-name": "Group 85337",
    transform: "translate(1.029 1.029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4943",
    "data-name": "Ellipse 4943",
    cx: 3.087,
    cy: 3.087,
    rx: 3.087,
    ry: 3.087,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85338",
    "data-name": "Group 85338",
    transform: "translate(1.029 1.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241617",
    "data-name": "Path 241617",
    d: "M391.281,102.251a3.086,3.086,0,0,1,1.646-2.729,3.087,3.087,0,1,0,0,5.459A3.085,3.085,0,0,1,391.281,102.251Z",
    transform: "translate(-388.4 -99.164)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85339",
    "data-name": "Group 85339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241618",
    "data-name": "Path 241618",
    d: "M387.516,102.4a4.116,4.116,0,1,1,4.116-4.116A4.121,4.121,0,0,1,387.516,102.4Zm0-6.174a2.058,2.058,0,1,0,2.058,2.058A2.06,2.06,0,0,0,387.516,96.222Z",
    transform: "translate(-383.4 -94.164)",
    fill: "#8e8e8e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85343",
    "data-name": "Group 85343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85342",
    "data-name": "Group 85342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241619",
    "data-name": "Path 241619",
    fill: "none",
    stroke: "#444b54",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85352",
    "data-name": "Group 85352",
    transform: "translate(75.48 49.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85347",
    "data-name": "Group 85347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85344",
    "data-name": "Group 85344",
    transform: "translate(1.029 1.029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4944",
    "data-name": "Ellipse 4944",
    cx: 3.988,
    cy: 3.988,
    rx: 3.988,
    ry: 3.988,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85345",
    "data-name": "Group 85345",
    transform: "translate(1.029 1.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241620",
    "data-name": "Path 241620",
    d: "M375.464,247.459a3.986,3.986,0,0,1,2.136-3.53,3.988,3.988,0,1,0,0,7.061A3.986,3.986,0,0,1,375.464,247.459Z",
    transform: "translate(-371.76 -243.471)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85346",
    "data-name": "Group 85346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241621",
    "data-name": "Path 241621",
    d: "M371.777,248.506a5.017,5.017,0,1,1,5.017-5.017A5.023,5.023,0,0,1,371.777,248.506Zm0-7.977a2.959,2.959,0,1,0,2.959,2.959A2.962,2.962,0,0,0,371.777,240.529Z",
    transform: "translate(-366.76 -238.471)",
    fill: "#8e8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85351",
    "data-name": "Group 85351",
    transform: "translate(8.878 16.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85348",
    "data-name": "Group 85348",
    transform: "translate(1.029 1.029)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4945",
    "data-name": "Ellipse 4945",
    cx: 3.087,
    cy: 3.087,
    rx: 3.087,
    ry: 3.087,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85349",
    "data-name": "Group 85349",
    transform: "translate(1.029 1.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241622",
    "data-name": "Path 241622",
    d: "M417.573,325.054a3.084,3.084,0,0,1,1.749-2.779,3.087,3.087,0,1,0,0,5.558A3.085,3.085,0,0,1,417.573,325.054Z",
    transform: "translate(-414.897 -321.967)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_85350",
    "data-name": "Group 85350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241623",
    "data-name": "Path 241623",
    d: "M414.013,325.2a4.116,4.116,0,1,1,4.116-4.116A4.121,4.121,0,0,1,414.013,325.2Zm0-6.174a2.058,2.058,0,1,0,2.058,2.058A2.06,2.06,0,0,0,414.013,319.026Z",
    transform: "translate(-409.897 -316.968)",
    fill: "#8e8e8e"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_85354",
    "data-name": "Group 85354",
    transform: "translate(0 4.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241624",
    "data-name": "Path 241624",
    d: "M73.954,109.878l-5.54-6.637a8.1,8.1,0,0,0-11.355-1.006l-1.643,1.376c-3.474,2.687-6.277,1.046-9.516-.891A43.6,43.6,0,0,1,25.16,76.577a5.978,5.978,0,0,1,1.91-6.23l1.862-1.56a8.063,8.063,0,0,0,.979-11.342l-5.594-6.6A8.072,8.072,0,0,0,13,49.879L8.741,53.445A24.337,24.337,0,0,0,1.049,79.192a79.079,79.079,0,0,0,38.074,46.619c9.258,6,21.394,5.881,29.919-1.373l3.894-3.26A8.04,8.04,0,0,0,73.954,109.878ZM71.616,119.6l-.976.817-7.1-8.449a1.029,1.029,0,0,0-1.575,1.325l7.1,8.445-1.34,1.122C59.814,129.625,48.642,129.582,40.1,124A76.561,76.561,0,0,1,3.019,78.6a22.282,22.282,0,0,1,7.044-23.572l1.709-1.431,6.935,8.25a1.029,1.029,0,0,0,1.575-1.325L13.35,52.271h0l.972-.814a6.01,6.01,0,0,1,8.425.714l5.594,6.6a6,6,0,0,1-.73,8.435l-1.862,1.56a8.037,8.037,0,0,0-2.566,8.377A45.923,45.923,0,0,0,44.9,104.517c4,2.521,7.7,3.9,11.842.672l1.643-1.376a6.027,6.027,0,0,1,8.453.747l5.54,6.637a5.978,5.978,0,0,1-.759,8.4Z",
    transform: "translate(0 -42.321)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241625",
    "data-name": "Path 241625",
    d: "M224.408,20.392a19.356,19.356,0,0,0-16.813,9.774A19.293,19.293,0,0,0,193.348,64.6l1.01,7.655A1.036,1.036,0,0,0,196,72.94L202,68.35a19.439,19.439,0,0,0,19.948-9.519,19.3,19.3,0,1,0,2.463-38.439ZM195.5,54.941a1.029,1.029,0,0,1,0-2.058h5.838a1.029,1.029,0,1,1,0,2.058Zm6.63-10.24A1.029,1.029,0,0,1,201.1,45.73h-5.6a1.029,1.029,0,1,1,0-2.058h5.6A1.029,1.029,0,0,1,202.13,44.7Zm22.278,12.231a17.259,17.259,0,0,1-9.128-2.6,1.029,1.029,0,0,0-.809-.12l-6.3,1.685,1.688-6.286a1.03,1.03,0,0,0-.121-.812,17.287,17.287,0,1,1,14.673,8.135Z",
    transform: "translate(-147.561 -20.392)",
    fill: "#8e8e8e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralQueries);
export default __webpack_public_path__ + "static/media/GeneralQueries.aa557a362f1da0817e40ad59bbbc1d39.svg";
export { ForwardRef as ReactComponent };